import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/pool"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.00006H16V3.00006H15C13.9465 3.00937 12.9448 2.54362 12.273 1.73206L11.5 0.789062L10.727 1.73206C10.0552 2.54362 9.05351 3.00937 8 3.00006C6.94316 3.00545 5.93967 2.53637 5.266 1.72206L4.5 0.813063L3.735 1.72306C3.06091 2.53727 2.05702 3.006 1 3.00006H0V5.00006H1C2.27431 5.00112 3.51017 4.56362 4.5 3.76106C5.49007 4.56319 6.72577 5.00063 8 5.00006C9.27331 5.00526 10.5095 4.57119 11.5 3.77106C12.4905 4.57119 13.7267 5.00526 15 5.00006ZM16 10.0001H15C13.7267 10.0053 12.4905 9.57119 11.5 8.77106C9.4543 10.4133 6.541 10.4091 4.5 8.76106C3.51017 9.56363 2.27431 10.0011 1 10.0001H0V8.00006H1C2.05702 8.006 3.06091 7.53727 3.735 6.72306L4.499 5.81306L5.265 6.72206C5.94108 7.53027 6.93997 7.99811 7.99367 8.00003C9.04737 8.00196 10.048 7.53779 10.727 6.73206L11.5 5.78906L12.273 6.73206C12.9448 7.54362 13.9465 8.00937 15 8.00006H16V10.0001ZM16 15.0001H15C13.7267 15.0053 12.4905 14.5712 11.5 13.7711C9.4543 15.4133 6.541 15.4091 4.5 13.7611C3.51017 14.5636 2.27431 15.0011 1 15.0001H0V13.0001H1C2.05702 13.006 3.06091 12.5373 3.735 11.7231L4.499 10.8131L5.265 11.7221C5.94108 12.5303 6.93997 12.9981 7.99367 13C9.04737 13.002 10.048 12.5378 10.727 11.7321L11.5 10.7891L12.273 11.7321C12.9448 12.5436 13.9465 13.0094 15 13.0001H16V15.0001Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Pool16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Pool16 = createIcon(IconComponent);